/**
 * Test IDs for QA automation.
 */
export const testIds = {
  extensionCardConfigure: "extension-card-configure",
  extensionCardLearnMore: "extension-card-learn-more",
  extensionCardInstall: "extension-card-install",
  extensionCardUninstall: "extension-card-uninstall",
} as const;
